import { render, staticRenderFns } from "./TextReplyListItem.vue?vue&type=template&id=49c79512"
import script from "./TextReplyListItem.vue?vue&type=script&lang=js"
export * from "./TextReplyListItem.vue?vue&type=script&lang=js"
import style0 from "./TextReplyListItem.vue?vue&type=style&index=0&id=49c79512&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports